import styled from 'styled-components';

import { Box } from 'components/Box';
import { Breadcrumbs } from 'components/Breadcrumbs';
import { PrintHidden } from 'components/PrintHidden/PrintHidden';
import PostSearchInputContainer from 'containers/PostSearchInputContainer';
import { CmsApiPage } from 'modules/cms/api/types/CmsApiPage';
import { useCmsApiPageSubsite } from 'modules/cms/hooks';
import { breakpoints, colors, gutterWidth, shadows } from 'theme';

type Props = {
  content: CmsApiPage;
};

const BreadcrumbsContainer = styled.div`
  flex: 3;

  @media (min-width: ${breakpoints[1]}) {
    flex: 1;
  }
`;

export function SearchToolbar({ content }: Props) {
  const subsite = useCmsApiPageSubsite({ cmsApiPage: content });

  // TODO: Fix this the next time the file is edited.
  // @ts-expect-error TS(2532): Object is possibly 'undefined'.
  // eslint-disable-next-line prefer-destructuring
  const homePage = subsite.homePage;
  const isHomePage = homePage && homePage.url === content.url;
  const hasBreadcrumbs = !isHomePage;
  const links = [
    {
      // @ts-expect-error TS(2532): Object is possibly 'undefined'.
      title: subsite.publicName,
      to: `/${subsite && homePage.url}`,
      'data-qa-id': 'breadcrumbs-home-link',
    },
  ];

  if (!isHomePage) {
    links.push({
      title: content.title,
      // @ts-expect-error TS(2322): Type '{ pathname: string; state: { subsite: CmsApi... Remove this comment to see the full error message
      to: {
        pathname: `/${content.url}`,
        state: {
          subsite,
        },
      },
    });
  }

  return (
    <PrintHidden>
      <Box
        data-qa-id="search-toolbar"
        position="relative"
        zIndex={1}
        py={12}
        px={gutterWidth / 2}
        display="flex"
        flexWrap="wrap"
        alignItems="center"
        justifyContent="space-between"
        bg={colors.white}
        borderTop={`1px solid ${colors.inputGrey}`}
        boxShadow={shadows.toolbar}
      >
        <BreadcrumbsContainer>
          {hasBreadcrumbs && <Breadcrumbs links={links} />}
        </BreadcrumbsContainer>
        <PostSearchInputContainer
          // @ts-expect-error TS(2532): Object is possibly 'undefined'.
          homePageUrl={subsite.homePage.url}
          // @ts-expect-error TS(2532): Object is possibly 'undefined'.
          searchPlaceholderText={subsite.searchPlaceholderText}
          usageContext="searchToolbar"
        />
      </Box>
    </PrintHidden>
  );
}
